import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewChecked,
  OnChanges,
} from '@angular/core';
import {
  DrillInfo,
  TotalSummaryModel,
  TreeMap,
  FilterTableModel,
  StockSaleSummaryListModel,
  CustomerModel,
  StockSaleSummaryFilterModel,
  KanziActions,
} from '@kanzi-apes/kanzi-models';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import moment from 'moment';

@Component({
    selector: 'lib-kanzi-sales-treemap-chart',
    templateUrl: './kanzi-sales-treemap-chart.component.html',
    styleUrls: ['./kanzi-sales-treemap-chart.component.scss'],
    standalone: false
})
export class KanziSalesTreemapChartComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  // @ViewChild(DxTreeMapComponent, { static: true }) chart!: DxTreeMapComponent;
  @Input() customer: CustomerModel | null = null;
  private kongUrl = this.envService.environment!.kongApi;
  private salesTotalsUrl = `${this.kongUrl}${
    this.envService.environment!.apiModules.inventory
  }moves/type-totals-by-location/`;
  items: any[] = [];
  filters!: StockSaleSummaryFilterModel;
  drillInfos: DrillInfo[] = [];
  locations_total: number = 0;
  fromChildren = false;
  optionsColor: any;
  rangeDates: Date[] = [];

  constructor(
    private apiClientService: KanziRestClientService,
    private envService: EnvironmentService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.initTreeMapData();
    this.optionsColor = {
      type: 'gradient',
      palette: ['#93DE93', '#EB4034'],
      colorCodeField: 'value',
      colorizeGroups: false,
    };
  }

  ngAfterViewChecked() {
    // this.chart.instance.render();
  }

  customizeTooltip(arg: any) {
    const data = arg.node.data;
    let result = null;

    result =
      `<span class='nameLocation'>` +
      data.name +
      '</span><br/>Ventas: ' +
      arg.valueText;
    return {
      text: result,
    };
  }

  clearData() {
    this.rangeDates = [];
    this.items = [];
  }

  initTreeMapData(filters?: StockSaleSummaryFilterModel) {
    console.log('🚀 ~ KanziSalesTreemapChartComponent ~ filters:', filters);
    this.drillInfos = filters ? this.drillInfos : [];
    this.filters = filters
      ? filters
      : {
          page: 1,
          page_size: 1000,
          customer_id: this.customer ? this.customer.id : null,
          type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
          sub_location__type_id: 1,
        };
    this.apiClientService
      .get<StockSaleSummaryListModel>(
        this.salesTotalsUrl,
        this.filters,
        'Error al traer el resumen de las ventas.'
      )
      .subscribe((stockSaleSummaryList) => {
        this.items = [];
        stockSaleSummaryList.results.forEach((item, i) => {
          const display_name = item.sub_location.properties
            ? item.sub_location.properties.category
              ? `${item.sub_location.display_name} - ${item.sub_location.properties.category} - ${item.sub_location.properties.gender}`
              : item.sub_location.display_name
            : item.sub_location.display_name;
          this.items.push(
            new TreeMap(
              display_name,
              item.sub_location.id,
              item.total_amount,
              null,
              null,
              this.createItemsFromList(item.properties.tipo_producto)
            )
          );
        });
      });
  }

  nodeClick(e: any) {
    this.filters = {
      page: 1,
      page_size: 1000,
      parent_id: e.node.data.id,
      customer_id: this.filters.customer_id,
      type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
      created_min: this.filters.created_min ? this.filters.created_min : '',
      created_max: this.filters.created_max ? this.filters.created_max : '',
    };
    this.apiClientService
      .get<StockSaleSummaryListModel>(
        this.salesTotalsUrl,
        this.filters,
        'Error al traer el resumen de las ventas.'
      )
      .subscribe((list) => {
        if (list && list.count > 0) {
          e.node.data.value = null;
          e.node.data.items = [];
          list.results.forEach((item, i) => {
            const display_name = item.sub_location.properties
              ? item.sub_location.properties.category
                ? `${item.sub_location.display_name} - ${item.sub_location.properties.category} - ${item.sub_location.properties.gender}`
                : item.sub_location.display_name
              : item.sub_location.display_name;
            e.node.data.items.push(
              new TreeMap(
                display_name,
                item.sub_location.id,
                item.total_amount,
                e.node.data.id,
                e,
                this.createItemsFromList(item.properties.tipo_producto)
              )
            );
          });
          this.fromChildren = true;
          this.items = e.node.data.items;
          console.log(this.items);
          this.drill(e);
        }
      });
  }

  nodeParentBack(e: any, node: any) {
    this.filters = {
      page: 1,
      page_size: 1000,
      parent_id: node.data.parent_id,
      customer_id: this.filters.customer_id,
      type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
      created_min: this.filters.created_min ? this.filters.created_min : '',
      created_max: this.filters.created_max ? this.filters.created_max : '',
    };
    this.apiClientService
      .get<StockSaleSummaryListModel>(
        this.salesTotalsUrl,
        this.filters,
        'Error al traer el resumen de las ventas.'
      )
      .subscribe((list) => {
        if (list && list.count > 0) {
          node.data.value = null;
          node.data.items = [];
          list.results.forEach((item, i) => {
            const display_name = item.sub_location.properties
              ? item.sub_location.properties.category
                ? `${item.sub_location.display_name} - ${item.sub_location.properties.category} - ${item.sub_location.properties.gender}`
                : item.sub_location.display_name
              : item.sub_location.display_name;
            node.data.items.push(
              new TreeMap(
                display_name,
                item.sub_location.id,
                item.total_amount,
                node.data.id,
                e,
                this.createItemsFromList(item.properties.tipo_producto)
              )
            );
          });
          this.fromChildren = true;
          this.items = node.data.items;
          this.drill(e.node.data.parent_node);
        }
      });
  }

  drill(e: any) {
    this.drillInfos = [];
    for (let node = e.node.getParent(); node; node = node.getParent()) {
      if (this.drillInfos.length === 0) {
        this.drillInfos.unshift({
          text: node.label() || 'Ubicaciones',
          node: node,
        });
      }
    }

    if (this.drillInfos.length) {
      this.drillInfos.push({
        text: e.node.data.name,
        node: e,
      });
    }
  }

  drillInfoClick(e: any) {
    if (e) {
      if (e.node.data.parent_node) {
        this.nodeParentBack(e, e.node);
      } else {
        this.initTreeMapData();
      }
    }
  }

  selectDateRange(range: Date[]) {
    if (range[1]) {
      const initDate = moment(range[0]).format('MM/DD/YYYY');
      const endDate = moment(range[1]).format('MM/DD/YYYY');
      const filter: StockSaleSummaryFilterModel = {
        ...this.filters,
        created_min: initDate,
        created_max: endDate,
      };
      this.initTreeMapData(filter);
    }
  }

  clearFilters() {
    this.initTreeMapData();
  }

  createItemsFromList(
    dataList: { value: string; amount: number }[]
  ): TreeMap[] {
    console.log('🚀 ~ KanziSalesTreemapChartComponent ~ dataList:', dataList);

    const items = dataList?.length
      ? dataList.map((data) => {
          return new TreeMap(
            `${data.value} - Ventas: ${data.amount}`,
            0,
            data.amount
          );
        })
      : [];
    return items;
  }
}
